export const escapeQuotes = str => str.replace(/"/g, '\\"').replace(/'/g, "\\'");